export const loadWebResources = async (lng: string) => {
  switch (lng) {
    case "en":
      return (await import("../assets/language/en/website2.website.json")).default;
    case "ca-ES":
      return (await import("../assets/language/ca-ES/website2.website.json")).default;
    case "en-US":
      return (await import("../assets/language/en-US/website2.website.json")).default;
    case "en-GB":
      return (await import("../assets/language/en-GB/website2.website.json")).default;
    case "es-MX":
      return (await import("../assets/language/es-MX/website2.website.json")).default;
    case "es-ES":
      return (await import("../assets/language/es-ES/website2.website.json")).default;
    case "de-DE":
      return (await import("../assets/language/de-DE/website2.website.json")).default;
    case "fr-FR":
      return (await import("../assets/language/fr-FR/website2.website.json")).default;
    case "fr-CA":
      return (await import("../assets/language/fr-CA/website2.website.json")).default;
    case "hi-IN":
      return (await import("../assets/language/hi-IN/website2.website.json")).default;
    case "id-ID":
      return (await import("../assets/language/id-ID/website2.website.json")).default;
    case "fil-PH":
      return (await import("../assets/language/fil-PH/website2.website.json")).default;
    case "pl-PL":
      return (await import("../assets/language/pl-PL/website2.website.json")).default;
    case "pt-BR":
      return (await import("../assets/language/pt-BR/website2.website.json")).default;
    case "pt-PT":
      return (await import("../assets/language/pt-PT/website2.website.json")).default;
    case "tr-TR":
      return (await import("../assets/language/tr-TR/website2.website.json")).default;
    case "th-TH":
      return (await import("../assets/language/th-TH/website2.website.json")).default;
    case "ru-RU":
      return (await import("../assets/language/ru-RU/website2.website.json")).default;
    case "uk-UA":
      return (await import("../assets/language/uk-UA/website2.website.json")).default;
    // case "ar-AR":
    //   return (await import("../assets/language/ar-AR/website2.website.json")).default;
    case "ko-KR":
      return (await import("../assets/language/ko-KR/website2.website.json")).default;
    case "zh-CN":
      return (await import("../assets/language/zh-CN/website2.website.json")).default;
    case "ja-JP":
      return (await import("../assets/language/ja-JP/website2.website.json")).default;
    case "vi-VN":
      return (await import("../assets/language/vi-VN/website2.website.json")).default;
    default:
      return (await import("../assets/language/en/website2.website.json")).default;
  }
};
